export const BUDGETING_QUERY_KEYS = {
  CAPABILITIES: 'budgeting_capabilities',
  PROJECT_ZONES: 'budgeting_project_zones',
  BUDGET_FOR_EDIT: 'budgeting_budget_for_edit',
  PROJECT_COST_CENTRES: 'budgeting_project_cost_centres',
} as const;
